import styles from './index.module.css'

import type { CellContext } from '@tanstack/react-table'
import React from 'react'

import type { Track } from 'types/track'

import { Badge, HoverCard, Text } from 'components/ds'

import { AppearsOnPlaylistsCard } from './appears-on-playlists-card'
import { loadTrackPlaylists } from './appears-on-playlists-card/playlists-loader'

type Props = { info: CellContext<Track, unknown> }

const AppearsOnColumnInternal = ({ info }: Props) => {
  const count = info.row.original.playlists_count
  const trackId = info.row.original.id

  const warmPlaylists = () => {
    loadTrackPlaylists(trackId).catch(() => {})
  }

  // Appears on is not available for MDS tracks (playlists_count is null).
  if (typeof count !== 'number') {
    return (
      <Text
        size="2"
        color="gray"
        className={styles.plainValue}
        data-testid="appears-on-cell"
      >
        —
      </Text>
    )
  }

  if (count === 0) {
    return (
      <Text
        size="2"
        color="gray"
        className={styles.plainValue}
        data-testid="appears-on-cell"
      >
        0
      </Text>
    )
  }

  return (
    <HoverCard.Root openDelay={300} closeDelay={100}>
      <HoverCard.Trigger>
        <Badge
          radius="full"
          className={styles.badge}
          data-testid="appears-on-cell"
          onMouseEnter={warmPlaylists}
          onFocus={warmPlaylists}
        >
          {count}
        </Badge>
      </HoverCard.Trigger>
      <HoverCard.Content
        size="1"
        side="bottom"
        align="start"
        minWidth="240px"
        maxWidth="360px"
        data-testid="appears-on-playlists-card"
        onClick={e => e.stopPropagation()}
      >
        <AppearsOnPlaylistsCard trackId={trackId} count={count} />
      </HoverCard.Content>
    </HoverCard.Root>
  )
}

export const AppearsOnColumn = React.memo(
  AppearsOnColumnInternal,
  (prev, next) =>
    prev.info.row.original.id === next.info.row.original.id &&
    prev.info.row.original.playlists_count ===
      next.info.row.original.playlists_count,
)

AppearsOnColumn.displayName = 'AppearsOnColumn'
